import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ANPC from '../../../../../common/assets/images/anpc-badge.png';
import { resources } from '../../../resources/resources';

export default function LitigationBadges() {
  const { t: translate } = useTranslation();

  return (
    <div className="footer-badges">
      <Link
        to={translate(resources.footer.aNPCLink)}
        target="_blank"
        rel="noreferrer"
      >
        <img src={ANPC} alt="Badge ANPC" />
      </Link>
    </div>
  );
}
